/* eslint-disable @typescript-eslint/typedef */
import React, { useState } from 'react';

import {
	Main,
	ListItem,
	DropDownList,
	DropDownHeader,
	DropDownContainer,
	DropDownListContainer
} from './styles';
import { ArrowDownIcon } from 'assets/Icons/Arrows/Arrowdown';

const options: any = ['INSTAGRAM', 'TIKTOK', 'YOUTUBE'];

export const SelectNetwork = (): JSX.Element => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedOption, setSelectedOption] = useState(null);

	const toggling = (): any => setIsOpen(!isOpen);

	const onOptionClicked = (value: any): any => (): any => {
		setSelectedOption(value);
		setIsOpen(false);
	};

	return (
		<Main>
			<DropDownContainer>
				<DropDownHeader onClick={toggling}>
					{selectedOption || 'INSTAGRAM'}
					<div className='ml ml-1.5'>
						<ArrowDownIcon />
					</div>
				</DropDownHeader>
				{isOpen && (
					<DropDownListContainer>
						<DropDownList>
							{options.map((option: any): any => (
								<ListItem onClick={onOptionClicked(option)} key={Math.random()}>
									{option}
								</ListItem>
							))}
						</DropDownList>
					</DropDownListContainer>
				)}
			</DropDownContainer>
		</Main>
	);
};